import {Injectable} from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';

@Injectable()
export class TokenStorage {

    constructor(private cookieService: CookieService,
        private router: Router) {

    }

    getItemLocalStorage(name: string): string {
        return localStorage.getItem(name);
    }

    setItemLocalStorage(name: string, value: string) {
        localStorage.setItem(name, value);
    }

    removeItemLocalStorage(name: string) {
        localStorage.removeItem(name);
    }

    setToken(token: string) {
        localStorage.setItem('ludyaccountToken', token);
    }

    getToken(): string {
        return localStorage.getItem('ludyaccountToken');
    }

    resetToken() {
        localStorage.removeItem('ludyaccountToken');
    }

    resetMaintenanceMsg() {
        localStorage.removeItem('maintenanceMsglac');
    }

    verifyCookieAndLocalStorage() {
        let cookieValue = this.cookieService.get('ludyaccountToken');
        if (cookieValue) {
            this.router.navigateByUrl('/home');
        }
    }

    getItemItemCookie(name: string): string {
        return this.cookieService.get(name);
    }

    setItemCookie(name: string, value: string) {
        this.cookieService.set( name, value, 10000, '/');
    }

    removeItemCookie(name: string) {
        this.cookieService.delete(name, '/');
    }

    setCookie(cookieValue: string) {
        this.cookieService.set( 'ludyaccountToken', cookieValue, 10000, '/');
    }

    getCookie(): string {
        return this.cookieService.get('ludyaccountToken');
    }

    deleteCookie() {
        this.cookieService.delete('ludyaccountToken', '/');
    }

}
